export const FEATURES = {
  REGISTER: 'register',
  PAYMENT: 'payment',
  AUTO_PAYMENT: 'auto_payment',
  DASHBOARD: 'dashboard',
  SHIPPING_CALCULATORS: 'shipping_calculators',
  POSTHOG: 'posthog',
}
